<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import { setBrowserCode } from "@/utils/browser-code";
import { md5 } from "js-md5";

export default {
  name: 'app',
  created () {
    // 缓存浏览器唯一识别码
    setBrowserCode(`api_${md5(navigator.userAgent)}`)
    this.$socket.connect(this)
    //本地开发
    if (window.seoConfig.length === 0) {
      this.getSeo();
    }
  },
  watch: {
    //通过watch来监听路由变化
    $route: {
      handler (newRoute, oldRoute) {
        if(newRoute.path === '/inquiry/result'){
          this.setMeta('viewport', 'width=device-width,initial-scale=1.0');
        }else{
          this.setMeta('viewport', '');
        }
        if (oldRoute) {
          this.$nextTick(() => {
            this.setSeo('route');
          });
        }
      },
      immediate: true
    },
  },
  methods: {
    getSeo () {
      this.$request.get('/Website/seo')
          .then(res => {
            if (res.code === 0) {
              window.seoConfig = res.data;
              this.setSeo('localInit');
            }
          })
    },
    setSeo (from) {
      if (!window.seoConfig.length) return;
      if (from === 'router' && document.title !== '{$title}') return;
      let data = this.$route;
      let result;
      result = window.seoConfig.filter((d) => {
        return d.url === decodeURI(data.fullPath);
      });
      if (!result.length) {
        result = window.seoConfig.filter((d) => {
          if (d.url.substring(d.url.length - 1) === '%') {
            return decodeURI(data.fullPath).indexOf(d.url.substring(0, d.url.length - 2)) === 0;
          }
          return false;
        });
      }
      if (!result.length) {
        result = window.seoConfig.filter((d) => {
          return d.url === '/';
        });
      }
      if (result.length === 1) {
        document.title = result[0].title;
        this.setMeta('keywords', result[0].keywords);
        this.setMeta('description', result[0].description);
      }
    },
    setMeta (type, text) {
      let meta = document.querySelector('meta[name="' + type + '"]');
      meta.setAttribute('content', text);
    },
  }
}
</script>

<style scoped lang="scss">
#app {
  overflow: hidden;
}
</style>

